// extracted by mini-css-extract-plugin
var _1 = "InformationEdit_text__Mxkyp";
export { _1 as "text" }
